<template>
  <div class="main pl-4 pb-5">
    <div class="title mb-3">CONFRONTA SCORE</div>
    <b-container class="my-4">
      <b-row class="header text-center">
        <b-col cols="4"><!--***-->Fase</b-col>
        <b-col cols="4"><!--***-->Serie</b-col>
        <b-col cols="4"><!--***-->Girone</b-col>
      </b-row>
      <b-row class="text-center">
        <b-col cols="4">
          <combo-or-label v-model="selectedPhase" :options="availablePhases"></combo-or-label>
        </b-col>
        <b-col cols="4">
          <combo-or-label v-model="selectedSerie" :options="availableSeries"></combo-or-label>
        </b-col>
        <b-col cols="4">
          <combo-or-label v-model="selectedSector" :options="availableSectors"></combo-or-label>
        </b-col>
      </b-row>
      <b-row class="header text-center">
        <b-col cols="4"><!--***-->Sessione</b-col>
        <b-col cols="4"><!--***-->Round</b-col>
        <b-col cols="4"><!--***-->Tavolo</b-col>
      </b-row>
      <b-row class="text-center">
        <b-col cols="4">
          <combo-or-label v-model="selectedSession" :options="availableSessions"></combo-or-label>
        </b-col>
        <b-col cols="4">
          <combo-or-label v-model="selectedRound" :options="availableRounds"></combo-or-label>
        </b-col>
        <b-col cols="4">
          <combo-or-label v-model="selectedTable" :options="availableTables"></combo-or-label>
        </b-col>
      </b-row>
    </b-container>
    <b-table :fields="fieldsToBeShown" :items="scores" small striped>
      <template #thead-top="">
        <b-tr v-if="showImps">
          <b-th colspan="5">
            <div v-if="currentMatch != null">
              <div style="width: 50%; float: left;" class="homeColor">{{ currentMatch.TeamHName }}</div>
              <div style="width: 50%; float: left;" class="visitColor">{{ currentMatch.TeamVName }}</div>
            </div>
          </b-th>
          <b-th class="text-right">Tot.</b-th>
          <b-th class="homeColor">{{ scores.map(sc => sc.Score.HomeTeamImps).reduce((a, b) => a + b, 0) }}</b-th>
          <b-th class="visitColor">{{ scores.map(sc => sc.Score.VisitorTeamImps).reduce((a, b) => a + b, 0) }}</b-th>
          <b-th></b-th>
        </b-tr>
      </template>
      <template #cell(ac)>
        A<br>
        C
      </template>
      <template #cell(contracts)="data">
        <div v-html="addColorToSuit(data.item.Score.OpenContract) + '&nbsp;' + data.item.Score.OpenDich"></div>
        <div v-html="addColorToSuit(data.item.Score.ClosedContract) + '&nbsp;' + data.item.Score.ClosedDich"></div>
      </template>
      <template #cell(lead)="data">
        <div v-html="addColorToSuit(data.item.Score.RawOpenAtt) || '&nbsp;'"></div>
        <div v-html="addColorToSuit(data.item.Score.RawClosedAtt) || '&nbsp;'"></div>
      </template>
      <template #cell(ptScore)="data">
        <div v-html="data.item.Score.OpenRoomScore || '&nbsp;'"></div>
        <div v-html="data.item.Score.ClosedRoomScore || '&nbsp;'"></div>
      </template>
      <template #cell(himps)="data">
        <div class="homeColor">{{ data.item.Score.HomeTeamImps || '&nbsp;' }}</div>
      </template>
      <template #cell(vimps)="data">
        <div class="visitColor">{{ data.item.Score.VisitorTeamImps || '&nbsp;' }}</div>
      </template>
      <template #cell(scoDiff)="data">
        {{
          data.item.Score.OpenRoomScore === "" || data.item.Score.ClosedRoomScore === "" ? '&nbsp;' : (data.item.Score.OpenRoomScore - data.item.Score.ClosedRoomScore)
        }}
      </template>
      <template #cell(show_details)="row">
        <b-icon-search
            v-if="!row.detailsShowing && row.item.Deal != null && row.item.Deal.N !== null && (row.item.Score.OpenRoomScore !== '' || row.item.Score.ClosedRoomScore !== '')"
            @click="openDetails(row.item.key)"></b-icon-search>
      </template>

      <template #row-details="row">
        <deal :deal="row.item.Deal" :deal-number="row.item.BoardNumber" class="mt-3" ref="deal"></deal>
        <b-button class="mt-4 float-right" variant="primary" @click="closeDetails">Chiudi</b-button>
      </template>
    </b-table>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import ComboOrLabel from "../components/lib/ComboOrLabel";
import Deal from "../components/display/Deal";
import {addColorToSuite as _addColorToSuite} from "../lib/cardSuits";

export default {
  name: 'TeamScoreViewer',
  components: {Deal, ComboOrLabel},
  data() {
    return {
      selectedPhase: 1,
      selectedSerie: 1,
      selectedSector: 1,
      selectedSession: 1,
      selectedRound: 1,
      selectedTable: 1,
      currentDetailsId: -1
    };
  },
  computed: {
    ...mapGetters({
      players: 'players/playersList',
      played: 'deals/played',
      sectors: 'tournament/sector',
      matches: 'matches/matches'
    }),
    scores() {
      const that = this;
      const baseKey = this.selectedSerie + "_"
          + this.selectedSerie + "_"
          + this.selectedSector + "_"
          + this.selectedSession + "_"
          + this.selectedRound + "_"
          + this.selectedTable;

      const played = this.played
          ?.Phases[this.selectedPhase]
          ?.Series[this.selectedSerie]
          ?.Groups[this.selectedSector]
          ?.Sessions[this.selectedSession]
          ?.Rounds[this.selectedRound]
          ?.Deals;

      let currentRoundReducedMap =
          Object.entries(
              this.played
                  ?.Phases[this.selectedPhase]
                  ?.Series[this.selectedSerie]
                  ?.Groups[this.selectedSector]
                  ?.Sessions[this.selectedSession]
                  ?.Rounds[this.selectedRound]
                  ?.Tables[this.selectedTable]
                  ?.Scores ?? {}
          ).map(row => {
            let boardNumber;
            let score;
            [boardNumber, score] = row;
            const ret = {...score, BoardNumber: boardNumber, Deal: played[boardNumber]};

            ret.key = baseKey + "_" + boardNumber;
            ret._showDetails = ret.key === that.currentDetailsId;
            return ret;
          });
      return currentRoundReducedMap != null ? currentRoundReducedMap.sort((a, b) => a.Number - b.Number) : [];
    },
    currentMatch() {
      return this.matches.find(match =>
          match.Serie === this.selectedSerie &&
          match.Group === this.selectedSector &&
          match.Session === this.selectedSession &&
          match.Round === this.selectedRound &&
          match.Table === this.selectedTable
      );
    },
    availablePhases() {
      return Object.keys(this.played?.Phases ?? {}).sort((a, b) => a - b);
    },
    availableSeries() {
      return Object.keys(
          this.played.Phases[this.selectedPhase]?.Series ?? {}
      ).map(seriesId => {
        return {
          value: seriesId,
          text: this.sectors.Phases[this.selectedPhase].Series[seriesId].Sigla
        }
      }).sort((a, b) => a.text.localeCompare(b.text));
    },
    availableSectors() {
      return Object.keys(
          this.played
              ?.Phases[this.selectedPhase]
              ?.Series[this.selectedSerie]
              ?.Groups ?? {}
      ).map(groupId => {
        return {
          value: groupId,
          text: this.sectors.Phases[this.selectedPhase].Series[this.selectedSerie].Sessions[this.selectedSession].Groups[groupId].Sigla
        }
      }).sort((a, b) => a.text.localeCompare(b.text));
    },
    availableSessions() {
      if (this.selectedSector === -1) {
        return [];
      }
      return Object.keys(
          this.played
              ?.Phases[this.selectedPhase]
              ?.Series[this.selectedSerie]
              ?.Groups[this.selectedSector]
              ?.Sessions ?? {}
      ).sort((a, b) => a - b);
    },
    availableRounds() {
      if (this.selectedSession === -1) {
        return [];
      }
      return Object.keys(
          this.played
              ?.Phases[this.selectedPhase]
              ?.Series[this.selectedSerie]
              ?.Groups[this.selectedSector]
              ?.Sessions[this.selectedSession]
              ?.Rounds ?? {}
      ).sort((a, b) => a - b);
    },
    availableTables() {
      if (this.selectedRound === -1) {
        return [];
      }
      return Object.keys(
          this.played
              ?.Phases[this.selectedPhase]
              ?.Series[this.selectedSerie]
              ?.Groups[this.selectedSector]
              ?.Sessions[this.selectedSession]
              ?.Rounds[this.selectedRound]
              ?.Tables ?? {}
      ).sort((a, b) => a - b);
    },


    showImps() {
      return this.scores.every(scr => scr.Score.OpenRoomScore !== "" && scr.Score.ClosedRoomScore !== "");
    },
    fieldsToBeShown() {
      return [
        {
          key: 'BoardNumber',
          label: '#'
        },
        {
          key: 'ac',
          label: ''
        },
        {
          key: 'contracts',
          label: ''
        },
        {
          key: 'lead',
          label: ''
        },
        {
          key: 'ptScore',
          label: '',
          tdClass: 'text-right'
        },
        ...(this.showImps ? [
          {
            key: 'scoDiff',
            label: 'Diff.',
            tdClass: 'text-right',
            thClass: 'text-center'
          },
          {
            key: 'himps',
            label: 'H'
          },
          {
            key: 'vimps',
            label: 'V'
          }] : []),
        {
          key: 'show_details',
          label: ''
        }
      ];
    }
  },
  methods: {
    openDetails(number) {
      this.currentDetailsId = number;
    },
    closeDetails() {
      this.currentDetailsId = "";
    },
    addColorToSuit(contract) {
      return _addColorToSuite(contract);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.selectedPhase = Math.max(...this.availablePhases);
      this.$nextTick(() => {
        this.selectedSession = Math.max(...this.availableSessions);
        this.$nextTick(() => {
          this.selectedRound = Math.max(...this.availableRounds);
        });
      });
    });
  }
};
</script>

<style scoped>

table tr td {
  border: 1px solid black;
}

.header {
  font-weight: bold;
}

/deep/ .table > tbody > tr > td {
  vertical-align: middle;
}

/deep/ ._htmlSuiteClass {
  font-size: 1.2rem;
}

/deep/ .homeColor {
  font-weight: bold;
  color: #2661CE;
}

/deep/ .visitColor {
  font-weight: bold;
  color: #DC143C;
}

.title {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  color: #3396B8;
}


</style>
